// Messages from the Iframe to the Widget => iframe.subscribe(...
export const IframeEvents = {
  OPEN: "open",
  HEIGHT_CHANGE: "height-change",
  ADD_TO_SLIP: "add-selections",
  REMOVE_FROM_SLIP: "remove-selections",
  EDIT: "edit-selections",
  ANALYTICS: "analytics",
  LOADED: "loaded",
} as const;

export type IframeEvents = (typeof IframeEvents)[keyof typeof IframeEvents];

// Messages from the widget to the Iframe => iframe.publish(...
export const IframeActions = {
  UPDATE_BETSLIP: "update-bet-builder-betslip",
  UPDATE_BETSLIP_ACCA: "update-betslip",
  ODDS_FORMAT: "odds-format",
} as const;

export type IframeActions = (typeof IframeActions)[keyof typeof IframeActions];

// Message from the MessageBus to Widget => msgBus.subscribe(...
export const MsgBusEvents = {
  START: "wh.sb.widgetIframeIntegrations.start",
  STOP: "wh.sb.widgetIframeIntegrations.stop",
  CLEAR_SLIP: "betslip.events.slip.clear.success",
  UPDATE_BETSLIP: "wh.sports.betslip.headless.selections",
  ODDS_FORMAT_CHANGE: "wh.sports.event.oddsformat.changed",
  ODDS_FORMAT_CHANGE_MOBILE: "onOddsFormatChanged",
} as const;

export type MsgBusEvents = (typeof MsgBusEvents)[keyof typeof MsgBusEvents];

// Messages from the Widget to the MessageBus => msgBus.publish(...
export const MsgBusActions = {
  ADD_TO_SLIP_BB: "wh.sports.betslip.adapter.byo.legs.add",
  ADD_TO_SLIP: "wh.sports.betslip.adapter.legs.add",
  WIDGET_LOADED: "wh.sports.widgetIframeIntegrations.loaded",
  ODDS_FORMAT_CHANGE: "wh.sports.event.oddsformat.changed",
  ODDS_FORMAT_CHANGE_MOBILE: "onOddsFormatChanged",
  STOP: "wh.sb.widgetIframeIntegrations.stop",
  REMOVE_FROM_SLIP: "wh.sports.betslip.adapter.leg.remove",
  START_SUCCESS: "wh.sb.widgetIframeIntegrations.start_success",
  STOP_SUCCESS: "wh.sb.widgetIframeIntegrations.stop_success",
  INIT_SUCCESS: "wh.sb.widgetIframeIntegrations.init_success",
  INIT_ERROR: "wh.sb.widgetIframeIntegrations.init_error",
  EDIT: "wh.sports.buildYourOdds.edit.selection",
} as const;

export type MsgBusActions = (typeof MsgBusActions)[keyof typeof MsgBusActions];
